module.exports = __webpack_public_path__ + "media/images/emblems/Birwinken-Blazono-248681bffb04e9197408e70795a08ef2.png";